import React from 'react'
import LazyImage from './LazyImage'

function About() {
  return (
    <>
    <section class="bg-white ">
        <div class="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-16 lg:px-6">
            <div class="font-light text-black sm:text-lg ">
                <h2 class="mb-4 text-4xl font-extrabold text-gray-900">Who We are,</h2>
                <p class="mb-4 text-justify">Tisson Lanka (PVT) LTD is a premier importer, distributor, and manufacturer of high-quality electronic home appliances, electricals, and stationery in Sri Lanka. Located in the picturesque town of Matale, our state-of-the-art facility serves as the nerve center for our operations, ensuring that every product we deliver meets the highest standards of quality and performance. Our journey began with a vision to bring the latest and most efficient home appliances from China and India to Sri Lankan households, enhancing their everyday lives with innovative technology.</p>
                <p>At Tisson Lanka, we pride ourselves on our commitment to excellence and customer satisfaction.......</p>
            </div>
            <div class="grid grid-cols-2 gap-4 mt-8">
              
                <LazyImage class="w-full rounded-lg" src="/about1.png" alt="ImportExport"/>
                <LazyImage class="mt-4 w-full lg:mt-10 rounded-lg" src="/about2.png" alt="ImportExport"/>
              
            </div>
        </div>
    </section>
    </>
  )
}

export default About